import TransactionsCollection from "./TransactionsCollection"

export default TransactionsCollection
